<template>
  <v-expansion-panels>
    <v-expansion-panel class="mb-3">
      <v-expansion-panel-header>
        <span>Configuração</span>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-chip
              :disabled="quantidadeFiltrosAplicados === 0"
              :color="quantidadeFiltrosAplicados !== 0 ? 'primary' : ''"
              text-color="white"
              style="max-width: 32px"
              v-on="on"
            >
              <span>
                {{ quantidadeFiltrosAplicados }}
              </span>
            </v-chip>
          </template>
          <span>Quantidade de filtros aplicados</span>
        </v-tooltip>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <!-- <template v-slot:header class="card-title"> -->
        <!-- <span>Configuração</span> -->
        <!-- <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-chip :disabled="quantidadeFiltrosAplicados === 0" :color="quantidadeFiltrosAplicados !== 0 ? 'primary' : ''" v-on="on" text-color="white" small>{{ quantidadeFiltrosAplicados }}</v-chip>
          </template>
          <span>Quantidade de filtros aplicados</span>
        </v-tooltip> -->
        <!-- </template> -->
        <v-container fluid grid-list-lg class="py-0">
          <v-layout>
            <v-flex xs3>
              <v-select outlined label="Tipo de pessoa" :items="listaTipoPessoa" :value="filter['tipo_pessoa']" @input="updateFilter($event, 'tipo_pessoa')" />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs3>
              <v-select outlined label="Fidelidade" :items="listaFidelidade" :value="filter['fidelidade']" @input="updateFilter($event, 'fidelidade')" />
            </v-flex>

            <v-flex xs3>
              <v-select outlined label="Gênero" :items="listaGenero" :value="filter['genero']" @input="updateFilter($event, 'genero')" />
            </v-flex>
            <v-flex xs3>
              <v-select outlined label="Faixa etária" :items="listaFaixaEtaria" :value="filter['faixa_etaria']" @input="updateFilter($event, 'faixa_etaria')" />
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider />
        <v-container fluid grid-list-lg class="pt-3 pb-0">
          <v-layout>
            <v-flex xs3>
              <mf-select-units-dialog
                ref="mfSelectUnitsDialog"
                outlined
                check-all-units-on-init
                required
                label="Lojas"
                :selected-units.sync="selectedUnits"
                :selected-units-configuration.sync="filter['unidade']"
                :units="units"
                :tag-list="tagList"
                :group-list="unitsGroups"
                enable-inactive-units-selection
                @change="updateFilter(filter['unidade'], 'unidade')"
              />
            </v-flex>
            <v-flex xs3>
              <date-picker
                v-if="ultimoRegistro"
                outlined
                :date.sync="data"
                label="Retenção até"
                type="month"
                :max="ultimoRegistro.toFormat('yyyy-MM-dd')"
                @input="updateFilter([$event], 'date')"
              />
            </v-flex>
            <v-flex xs3>
              <segmentos-dialog outlined label="Segmentos" :required="false" :selecionados.sync="selectedSegments" template-type="input" />
            </v-flex>
          </v-layout>
          <mf-action-buttons
            :primary-button="{
              text: 'Aplicar',
              action: () => aplicar(),
              isVisible: true,
            }"
            :cancel-button="{
              text: 'Limpar',
              action: limpar,
              isVisible: true,
            }"
          />
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapKeys } from 'lodash'
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import DatePicker from '@/components/DatePicker.vue'
export default {
  components: {
    DatePicker,
    SegmentosDialog: () => import('@/modules/campanhas/views/components/SegmentosDialog.vue'),
  },
  props: {
    filter: Object,
    tableLength: Number,
  },
  data: () => ({
    listaLojas: [],
    data: null,
    quantidadeFiltrosAplicados: 0,
    localSelectedSegments: [],
    selectedUnits: [],
  }),
  computed: {
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
    selectedSegments: {
      get() {
        return this.localSelectedSegments
      },
      set(value) {
        this.localSelectedSegments = value
        this.updateFilter(
          value.map((segment) => segment._id),
          'segmentos'
        )
      },
    },
    datasLimites() {
      return this.$store.getters.datasLimites
    },
    primeiroRegistro() {
      if (this.datasLimites['DAT_DATA_PRIMEIRO_REGISTRO']) {
        return DateTime.fromFormat(this.datasLimites['DAT_DATA_PRIMEIRO_REGISTRO'].toString(), 'yyyy-MM-dd HH:mm:ss')
      }
      return ''
    },
    ultimoRegistro() {
      if (this.datasLimites['DAT_DATA_ULTIMO_REGISTRO']) {
        return DateTime.fromFormat(this.datasLimites['DAT_DATA_ULTIMO_REGISTRO'].toString(), 'yyyy-MM-dd HH:mm:ss')
      }
      return ''
    },
    listaFidelidade() {
      return [
        { text: 'Todos', value: '' },
        { text: 'Fidelidade', value: '1' },
        { text: 'Não fidelidade', value: '0' },
      ]
    },
    listaTipoPessoa() {
      return [
        { text: 'Todos', value: '' },
        { text: 'Pessoa física', value: 'F' },
        { text: 'Pessoa jurídica', value: 'J' },
      ]
    },
    listaGenero() {
      return [
        { text: 'Todos', value: '' },
        { text: 'Masculino', value: 'M' },
        { text: 'Feminino', value: 'F' },
        { text: 'Indefinido/outros', value: ' ' },
      ]
    },
    listaFaixaEtaria() {
      return [
        { text: 'Todos', value: '' },
        { text: '17 anos ou menos', value: '7' },
        { text: '18 a 24 anos', value: '1' },
        { text: '25 a 34 anos', value: '2' },
        { text: '35 a 44 anos', value: '3' },
        { text: '45 a 54 anos', value: '4' },
        { text: '55 a 64 anos', value: '5' },
        { text: '65 anos ou mais', value: '6' },
        { text: 'Pessoas jurídicas', value: '8' },
        { text: 'Indefinido/outros', value: '0' },
      ]
    },
  },
  watch: {
    'filter.grouping_size'(value) {
      this.fillDates(value)
    },
  },
  async mounted() {
    this.$store.dispatch('getStates', ['clientesDatasLimites']).then(() => {
      this.fillDates(this.filter.grouping_size).then(() => {
        this.$emit('updated')
      })
    })
  },
  methods: {
    updateFilter(value, attribute) {
      this.filter[attribute] = value
      this.$emit('update:filter', this.filter)
    },
    fillDates(value) {
      return new Promise((resolve) => {
        this.data = this.ultimoRegistro.toFormat('yyyy-MM')
        this.updateFilter([this.data], 'date')
        resolve()
      })
    },
    aplicar() {
      this.$emit('updated')
      this.atualizarFiltrosAplicados()
    },
    limpar() {
      this.selectedUnits = this.units.map((unit) => unit.id_erp)
      const unitsConfiguration = this.selectedUnits.map((unit) => {
        return { value: unit, dataType: ['PHYSICAL', 'ECOMMERCE'] }
      })
      this.data = this.ultimoRegistro.toFormat('yyyy-MM')
      this.$refs.mfSelectUnitsDialog.clearFilters()
      this.filter = {
        date: [this.ultimoRegistro.toFormat('yyyy-MM')],
        scale: 'monthly',
        fidelidade: '',
        tipo_pessoa: '',
        genero: '',
        faixa_etaria: '',
        unidade: unitsConfiguration,
        segmentos: [],
      }
      this.$emit('update:filter', this.filter)
      this.selectedSegments = []
      // this.$refs['lojas-dialog'].selectAll()
      // this.$refs['lojas-dialog'].confirmChanges()
      this.$nextTick(() => this.aplicar())
    },
    atualizarFiltrosAplicados() {
      this.quantidadeFiltrosAplicados = 0
      mapKeys(this.filter, (value, key) => {
        if (key !== 'scale' && key !== 'grouping_size' && value !== '' && value !== null) {
          if (value !== this.ultimoRegistro.toFormat('yyyy-MM')) {
            this.quantidadeFiltrosAplicados++
          }
        }
      })
    },
  },
}
</script>

<style lang="scss"></style>
